export default {
  US: 'Zipcode',
  GB: 'Postcode',
  IRELAND: 'Eircode',
  CYPRUS: 'Postcode',
};
